import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SugargooCompleteGuide from "../pages/article/sugargoo-spreadsheet-complete-guide/page";
import SugargooReview from "../pages/article/sugargoo-review/page";
import SugargooShippingCostGuide from "../pages/article/sugargoo-shipping-cost-guide/page";
import SugargooCouponGuide from "../pages/article/sugargoo-coupon-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-complete-guide",
    element: <SugargooCompleteGuide />,
  },
  {
    path: "/article/sugargoo-review",
    element: <SugargooReview />,
  },
  {
    path: "/article/sugargoo-shipping-cost-guide",
    element: <SugargooShippingCostGuide />,
  },
  {
    path: "/article/sugargoo-coupon-guide",
    element: <SugargooCouponGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;